import deepMapKeys from 'deep-map-keys'
import { snakeToCamelCase } from 'libs/utils/string'

const BASE_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

export class APIError extends Error {
  constructor(path, response) {
    super(`Error(s) returned from endpoint ${path}`)
    this.name = 'APIError'
    this.response = response
  }
}

const buildPath = (path) =>
  typeof process.env.API_URL === 'string'
    ? new URL(path, process.env.API_URL)
    : path

export const csrf = async () => {
  const path = '/api/v2/csrf-token'
  const response = await fetch(buildPath(path), {
    headers: { ...BASE_HEADERS },
  })
  const { token } = await response.json()

  if (response.errors) {
    throw new APIError(path, response)
  }

  return token
}

export const get = async (path = '') => {
  const request = await fetch(buildPath(path), {
    headers: {
      ...BASE_HEADERS,
    },
    credentials: 'include',
  })

  const response = await request.json()

  if (response.errors) {
    throw new APIError(path, response)
  }

  const mapped = deepMapKeys(response, snakeToCamelCase)

  return mapped
}

export const post = async (path, body) => {
  const token = await csrf()
  const request = await fetch(buildPath(path), {
    method: 'post',
    headers: {
      ...BASE_HEADERS,
      'X-CSRF-Token': token,
    },
    credentials: 'include',
    body: JSON.stringify(body),
  })

  try {
    const response = await request.json()

    if (response.errors) {
      throw new APIError(path, response)
    }

    const mapped = deepMapKeys(response, snakeToCamelCase)

    return mapped
  } catch (e) {
    return {}
  }
}

export const put = async (path, body) => {
  const token = await csrf()

  const request = await fetch(buildPath(path), {
    method: 'put',
    headers: {
      ...BASE_HEADERS,
      'X-CSRF-Token': token,
    },
    credentials: 'include',
    body: JSON.stringify(body),
  })

  const response = await request.json()

  if (response.errors) {
    throw new APIError(path, response)
  }

  const mapped = deepMapKeys(response, snakeToCamelCase)

  return mapped
}
